import { Component, OnInit } from '@angular/core';
import { first } from 'rxjs/operators';

import { SubscriptionPerformance } from '../../../_models';
import { SubscriptionPerformanceService, NotificationService } from '../../../_services';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-subscription-performance-detail',
  templateUrl: './subscription-performance-detail.component.html'
})
export class SubscriptionPerformanceDetailComponent implements OnInit {

  loading = true;

  totalItems = 0;
  emptyResult = true;
  subsReportLength = 0;
  reports = [];
  subscriptions: SubscriptionPerformance[];

  constructor(
    private router: Router,
    private subscriptionSvc: SubscriptionPerformanceService,
    private notification: NotificationService,
    private route: ActivatedRoute) {

  }

  ngOnInit(): void {
    let params = {
      from: this.route.snapshot.paramMap.get('from'),
      to: this.route.snapshot.paramMap.get('to'),
      source: this.route.snapshot.paramMap.get('source'),
      country: this.route.snapshot.paramMap.get('country'),
      shortCode: this.route.snapshot.paramMap.get('shortCode'),
      operator: this.route.snapshot.paramMap.get('operator'),
      client: this.route.snapshot.paramMap.get('client'),
      spiderAccount: this.route.snapshot.paramMap.get('spiderAccount'),
      realtime: this.route.snapshot.paramMap.get('realtime'),
      dateType: this.route.snapshot.paramMap.get('dateType'),
      reportType: 0,
    }
    this.loadPage(params);
  }

  close() {
    window.open('', '_self').close();
  }

  hiddenFlag = false;

  isDisplay(allZero) {
    return !allZero || !this.hiddenFlag
  }

  private loadPage(params) {
    // get page of items from api
    this.subscriptionSvc.getAll(params, params['realtime']).pipe(first()).subscribe(data => {
      if (data !== null && data.data.length > 0) {
        this.loading = false;
        this.emptyResult = false;
        this.subscriptions = data.data;
        this.totalItems = data.data.length;
        this.subsReportLength = this.subscriptions[0].reports.length;
        this.reports = this.subscriptions[0].reports;
      } else {
        this.loading = false;
        this.emptyResult = true;
        this.notification.showWarning("There is no report for this subscription.", "Empty Detail");
      }
    });
  }

}
